































































































































































import { Component, Vue } from "vue-property-decorator";
import {Action} from "vuex-class";
import {CdpDetailItemInfo} from "@/store/cdp/statistic/types";
import { colorClassByStatus } from "@/utils/page-utils";
import {dateFilter} from "@/utils/date-util";
import {getTranslatedParams} from "@/utils/notify-utils";
import {MsgTransports} from "@/store/types";
import {ActionLog} from "@/store/auth/types";
import {InputWings} from "wings-ui-components";

Component.registerHooks([
  'beforeRouteLeave',
]);
@Component({
  filters: {dateFilter},
  methods: {colorClassByStatus},
  components: {InputWings}
})
export default class CdpDetailInfo extends Vue {
  @Action("getCdpStatisticDetailInfo") actionGetStatisticDetailInfo: any;
  @Action("actionLog") actionLog: any;

  private messageInfo: CdpDetailItemInfo = new CdpDetailItemInfo();
  private transport = MsgTransports.CDP;
  private logObject: ActionLog = {};

  async created() {
    if (this.$route.params.id) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "Message",
          addititional_info: getTranslatedParams({channel: this.transport, message_id: this.$route.params.id})
        }
        await this.actionGetStatisticDetailInfo(this.$route.params.id).then((data: any) => {
          const api = data.data || data;
          this.messageInfo = Object.assign({}, this.messageInfo, api);
        });
        await this.actionLog(this.logObject);
      } catch (err){
        await this.actionLog({...this.logObject, action_status: "failed"});
      }
    }
  }

  parseToJson(value?: any){
    if (!value) return '';
    try {
      if (typeof value === 'string') {
        return JSON.stringify(JSON.parse(value), null, 2);
      }
      return JSON.stringify(value, null, 2);
    } catch (e) {
      return String(value);
    }
  }

  getEventType(value?: any): string {
    if (!value) return '';
    try {
      const data = typeof value === 'string' ? JSON.parse(value) : value;
      return data?.EVENT_TYPE || '';
    } catch (e) {
      return '';
    }
  }

  back(): void {
    this.$router.push('/cdp/detail/');
  }
}
